<template>
  <div class="container m-t-lg">
    <div class="columns">
      <div class="column content">
        <h2>
          Admin users
        </h2>
        <p>Here you may view and manage the LHHP System Administrators.</p> 
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="has-text-right">
          <button
            class="button is-primary"
            @click="newAdmin"
          >
            <span>New Admin</span>
            <span class="icon">
              <i
                class="fas fa-plus-square"
                aria-hidden="true"
              />
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <v-client-table
          class="custom-table-with-right-button-and-not-limit"
          :data="admins"
          :columns="tableColumns"
          :options="tableOptions"
        >
          <template
            slot="name"
            slot-scope="props"
          >
            {{ `${props.row.firstName} ${props.row.lastName}` }}
          </template>
          <template
            slot="actions"
            slot-scope="props"
          >
            <button
              class="button is-light has-text-primary"
              tag="button"
              :title="`View ${props.row.email}`"
              :aria-label="`View ${props.row.email}`"
              @click="updateAdmin(props.row)"
            >
              <span class="icon is-small">
                <i
                  class="fa fa-pencil"
                  aria-hidden="true"
                />
              </span>
            </button>
            <button
              v-if="props.row.isActive"
              :title="`Deactivate account for ${props.row.email}`"
              :aria-label="`Deactivate account for ${props.row.email}`"
              class="button is-light has-text-danger"
              @click="updateAdminStatus(props.row)"
            >
              <span
                class="icon is-small"
              >
                <i
                  class="fas fa-user-slash info-button"
                  aria-hidden="true"
                />
              </span>
            </button>
            <button
              v-else
              :title="`Activate account for ${props.row.email}`"
              :aria-label="`Activate account for ${props.row.email}`"
              class="button is-light has-text-primary"
              @click="updateAdminStatus(props.row)"
            >
              <span
                class="icon is-small"
              >
                <i
                  class="fas fa-user info-button"
                  aria-hidden="true"
                />
              </span>
            </button>
          </template>
        </v-client-table>
      </div>
    </div>
    <modal
      name="admin-user-modal"
      height="auto"
      :adaptive="true"
      :scrollable="true"
      @opened="isModalOn"
      @closed="isModalOff"
    >
      <div class="modal is-active">
        <admin-form
          :id="id"
          @close="$modal.hide('admin-user-modal')"
        />
      </div>
    </modal>
  </div>
</template>

<script>
import AdminForm from '@/components/AdminForm';
import { options } from '@/config/tableOptions';
export default {
  name: 'UsersPage',
  components: {
    AdminForm,
  },
  data() {
    return {
      id: null,
      tableOptions:  options({
        headings: {
          actions: '',
        },
        columnsClasses: {
          email: 'nowrap',
          actions: 'actions',
        },
        filterable: [],
      }),
      tableColumns: [
        'name',
        'email',
        'actions',
      ],
    };
  },
  computed: {
    admins() {
      return this.$store.state.users.admins;
    },
  },
  async beforeMount() {
    // Get all admins here.
    await this.$store.dispatch('users/getAdmins');
  },
  methods: {
    newAdmin() {
      this.id = null;
      this.$modal.show('admin-user-modal');
    },
    updateAdmin(row) {
      this.id = row.id;
      this.$modal.show('admin-user-modal');
    },
    async updateAdminStatus(row) {
      if (row.isActive) {
        if (await this.submitGuard(`Are you sure you want to deactivate ${row.email}?`)) {
          // Remove it here
          await this.$store.dispatch('users/disableAdmin', row);
        }
      } else {
        if (await this.submitGuard(`Are you sure you want to activate ${row.email}?`)) {
          row.isActive = true;
          await this.$store.dispatch('users/updateAdmin', row);
        }
      }
    },
  },
};
</script>
